import { personName } from 'Data/format.js'

export function formatAuthor(value) {
  return value ? personName(value) : 'N/A'
}
